// extracted by mini-css-extract-plugin
export var productImage = "_qr-1";
export var viewLink = "_qr-2";
export var wishlistItem = "_qr-0";